import { AbstractRequirementMapper } from '@/features/CompanyQuestions/RequirementMapping/AbstractRequirementMapper';

export class DefaultRequirement extends AbstractRequirementMapper {}
